export const columnsByName = name => {
  switch (name) {
    case 'students_in_class':
      return ['given_name', 'family_name', 'username'];
    case 'students_in_school':
      return ['given_name', 'family_name', 'username'];
    case 'teachers_in_school':
      return ['given_name', 'family_name', 'username'];
    case 'educators_stats':
      return [
        'full_name',
        'roles',
        'email',
        'school_name',
        'login_count',
        'last_login_at',
        'trial_remaining',
      ];
    case 'schools_stats':
      return [
        'school_name',
        'license_type',
        'admin_email',
        'admin_last_login',
        'total_logins',
        'educator_count',
        'student_count',
        'license_end',
        'admin_marketing_emails',
      ];
    default:
      return [];
  }
};

export const columnSizeByList = listId => {
  switch (listId) {
    case 'students_in_class':
    case 'students_in_school':
    case 'teachers_in_school':
      return {
        given_name: 'med',
        family_name: 'med',
        username: 'lg',
      };
    case 'educators_stats':
    case 'schools_stats':
      return {
        full_name: 'med',
        roles: 'sm',
        email: 'med',
        school_name: 'lg',
        license_type: 'sm',
        admin_email: 'med',
        admin_last_login: 'sm',
        last_login_at: 'sm',
        total_logins: 'xs',
        login_count: 'xs',
        educator_count: 'xs',
        student_count: 'xs',
        license_end: 'sm',
        admin_marketing_emails: 'xs',
        trial_remaining: 'sm',
      };
    default:
      return {};
  }
};
